import { call, put, select, take } from 'redux-saga/effects';

import { actions as globalActions } from '@elab/core/store/global';
import { actions as uiActions } from '@elab/core/store/ui';

import { selectors as uiSelectors, types as uiTypes } from '@elab/core/store/ui';
import selectors from '../../selectors';
import api from '../../api';
import { getNotifyMeListRedirectURL } from '../helpers';

// Add the product to the notify me list if product not in notify me list
// redirect to the notify me list if product in notify me list
// [Applied on: ICI]

export function* addWithRedirect(productCode) {
    yield call(addToNotifyMeList, productCode);

    const redirectURL = yield call(getNotifyMeListRedirectURL);
    yield put(uiActions.closeDialog());
    yield put(globalActions.redirect({ successRedirectUrl: redirectURL }));
}

export function* addWithDialog(productCode) {
    yield call(addToNotifyMeList, productCode);
    let isDialogOpen = yield select(uiSelectors.getDialogState, 'registrationSuccess');

    if (isDialogOpen) {
        yield take(uiTypes.CLOSE_DIALOG);
        isDialogOpen = yield select(uiSelectors.getDialogState, 'registrationSuccess');
    }
    if (!isDialogOpen) {
        yield put(uiActions.openDialog({ name: 'notify-me-popup' }));
    }
}

export function* addToNotifyMeList(productCode) {
    const isProductInNotifyMeList = yield select(selectors.getEntry, productCode);

    if (!isProductInNotifyMeList) {
        yield call(api.addToNotifyMeList, productCode);
    }

    yield call(api.updateNotificationPreferences);
}
